export const SaleBankInfoBlock = () => {
  return (
    <div className="rounded-xl bg-[#505CFF14] p-3 space-y-[2px]">
      <h4 className="text-md font-semibold text-[#505CFF]">Реквизиты для выплат вознаграждений</h4>
      <p className="text-sm text-[#575E74]">
        Реквизиты вы можете найти в приложении или в ЛК своего банка. Зачастую достаточно открыть
        нужную карту и нажать что-то вроде «Реквизиты» или «Показать полные данные». Если у вас
        возникли проблемы с поиском реквизитов, пожалуйста, обратитесь в чат поддержки своего банка.
        Оставляя эти данные вы ничем не рискуете реквизиты могут быть использованы исключительно для
        получения переводов.
      </p>
    </div>
  );
};
